// extracted by mini-css-extract-plugin
export var dropdown = "_uc-0";
export var imageWrapper = "_uc-3";
export var itemNameContainer = "_uc-1";
export var productImage = "_uc-2";
export var spinnerWrapper = "_uc-4";